"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  query isSuperUser {
    isSuperUser
  }
`;
exports.default = query;
//# sourceMappingURL=isSuperUser.query.js.map